// institute
import pgcImage from './assets/institute/pgc.jpg';
import ucpImage from './assets/institute/ucp.jpg';
import vubImage from './assets/institute/vub.jpg';

// companies
import fieztechImage from './assets/companies/fieztech.jpg';
import cloudbedrockImage from './assets/companies/cloud_bedrock_llc.jpg';
import invozoneImage from './assets/companies/invozone.jpg';
import silverbackaiImage from './assets/companies/silverbackai.jpg';
import cybernestImage from './assets/companies/cybernest.jpg';

// projects
import retainooImage from './assets/projects/retainoo.png';
import appworkcoImage from './assets/projects/appworkco.png';
import looperinsightsImage from './assets/projects/looperinsights.png';
import freshprepImage from './assets/projects/freshprep.png';
import invoteamsImage from './assets/projects/invoteam.png';
import vintagedomusImage from './assets/projects/vintagedomus.png';
import z98Image from './assets/projects/z98.png';
import cloudbedImage from './assets/projects/cloudbed.png';

// feedbacks
import cloudbedFiverrFeedback from './assets/feedbacks/cloudbedFiverrFeedback.png';
import vintagedomusFiverrFeedback from './assets/feedbacks/vintagedomusFiverrFeedback.png';
import z98FiverrFeedback from './assets/feedbacks/z98FiverrFeedback.png';
import tschangoFiverrFeedback from './assets/feedbacks/tschangoFiverrFeedback.png';
import upworkFeedback from './assets/feedbacks/upworkFeedback.png';
import upworkFeedback1 from './assets/feedbacks/upworkFeedback1.png';
import martinFreelancerFeedback from './assets/feedbacks/martinFreelancerFeedback.png';
import nathanFreelancerFeedback from './assets/feedbacks/nathanFreelancerFeedback.png';

// platforms
import fiverrIcon from './assets/FiverrIcon.png'
import upworkIcon from './assets/UpworkIcon.png'
import freelancerIcon from './assets/freelancerIcon.png'

import avatar from './assets/avatar.png'

const header = {
  homepage: '/',
  title: 'USMAN.',
}

const about = {
  name: 'Usman Ahmed',
  role: 'Full-Stack Software Engineer',
  description: '',
  avatar,
  // description: 'Empowering innovation through sustainable and scalable full-stack development.',
  resume: 'https://example.com', // it is handeled in about.js
  socialLinks: {
    linkedin: 'https://www.linkedin.com/in/oxm-ahmed/',
    github: 'https://github.com/usmansohee',
    fiverr: 'https://www.fiverr.com/usmanahmed905',
    upwork: 'https://www.upwork.com/freelancers/~01be464d43b359d81d',
    freelancer: 'https://www.freelancer.com/u/oxmahmed'
  },
}

const feedbacks = [
  {
    name: 'Jim Hankins',
    position: 'CEO / Founder - Cloud Bedrock, LLC',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: fiverrIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [cloudbedFiverrFeedback],
  },
  {
    name: 'Valeria',
    position: 'Vintage Domus',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: fiverrIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [vintagedomusFiverrFeedback],
  },
  {
    name: 'Phil Cook.',
    position: 'Ottawa Executive Airport',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: fiverrIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [z98FiverrFeedback],
  },
  {
    name: 'Tschango',
    position: 'Product Owner',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: fiverrIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [tschangoFiverrFeedback],
  },
  {
    name: 'Alex',
    position: 'Story Candle LLC',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: upworkIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [upworkFeedback],
  },
  {
    name: 'Daniel Blokh',
    position: 'eRated Inc. (SilverBack.ai)',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: upworkIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [upworkFeedback1],
  },
  {
    name: 'Nathan A.',
    position: 'Owner - Unique Leverage',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: freelancerIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [nathanFreelancerFeedback],
  },
  {
    name: 'Martin K.',
    position: 'Owner - Knuthia WIZ',
    feedback: 'Usman did a great job working on migrating a site from Nuxt3 to Phoenix. The project was delivered very quickly, ahead of expectations. Great communication. A pleasure to work with. Highly recommended.',
    platformIcon: freelancerIcon,
    links: ['https://www.fiverr.com/usmanahmed905'],
    images: [martinFreelancerFeedback],
  },
]

const contact = {
  email: 'uxmansohee@gmail.com',
  phone: '+923046080940'
}

const experiences = [
  {
    company: 'FiezTech Pvt Ltd.',
    icon: fieztechImage,
    position: 'Full-Stack Software Engineer',
    from: 'Mar 2024',
    to: 'Present',
    location: 'United States',
    description: 'Remote',
    responsibilities: ["Amet asperiores et impedit aliquam consectetur? Voluptates",
      "Amet asperiores et impedit aliquam consectetur? Voluptates"
    ],
    stack: ['nodejs', 'reactjs', 'typescript', 'redux', 'jest', 'postgreql', 'mongodb', 'github', 'aws', 'ec2', 'linux', 'digitalocean', 'heroku', 'postman'],
  },
  {
    company: 'Cloud Bedrock, LLC',
    icon: cloudbedrockImage,
    position: 'Elixir Developer',
    from: 'Sep 2023',
    to: 'Mar 2024',
    location: 'United States',
    description: 'Remote',
    responsibilities: [],
    stack: ['elixir', 'phoenix', 'nextjs', 'postgresql', 'elastic', 'github', 'aws', 'docker', 'html5', 'css3', 'tailwindcss'],
  },
  {
    company: 'InvoZone Pvt Ltd.',
    icon: invozoneImage,
    position: 'Software Engineer',
    from: 'Aug 2021',
    to: 'Sep 2023',
    location: 'United States',
    description: 'Remote',
    responsibilities: [],
    stack: ['rails', 'elixir', 'phoenix', 'nodejs', 'reactjs', 'redux', 'vuejs', 'typescript', 'bootstrap', 'github', 'gitlab', 'bitbucket', 'postgresql', 'redis', 'aws', 'ec2', 'docker', 'rest api', 'graphql', 'circleci', 'jest', 'rspec', 'jira', 'postman', 'slack'],
  },
  {
    company: 'Silverback.ai',
    icon: silverbackaiImage,
    position: 'Software Developer',
    location: 'Tel Aviv, Israel',
    from: 'Nov 2021',
    to: 'Mar 2023',
    description: 'Remote',
    responsibilities: [],
    stack: ['ruby', 'reactjs', 'python', 'slack'],
  },
  {
    company: 'Cybernest Pvt Ltd.',
    icon: cybernestImage,
    position: 'Associate Software Engineer',
    location: 'Lahore, Pakistan',
    from: 'Mar 2021',
    to: 'Aug 2021',
    description: 'Hybrid',
    responsibilities: [],
    stack: ['ruby', 'rails', 'javascript', 'reactjs', 'html5', 'css3', 'mysql', 'git', 'jira', 'postman'],
  },
]

const projects = [
  {
    name: 'Cloudbedrock',
    from: 'July 2024',
    to: 'Sept 2023',
    headline: 'AI-Powered hiring software solution for streamlined software development',
    description: 'AI-Powered hiring software solution for streamlined software development',
    features: [],
    responsibilities: [],
    associatedWith: 'FiezTech Pvt Ltd',
    stack: ['rails', 'reactjs', 'redux', 'nodejs', 'elixir', 'bootstrap', 'gitlab', 'postgresql', 'microservices', 'aws', 'ec2', 'rest api', 'jira', 'postman', 'slack'],
    images: [cloudbedImage],
    domains: ['https://invoteams.com/'],
    sourceCode: '',
  },
  {
    name: 'Fuel Tracking Z98',
    from: 'May 2024',
    to: 'July 2023',
    headline: 'AI-Powered hiring software solution for streamlined software development',
    description: 'AI-Powered hiring software solution for streamlined software developmentm',
    features: [],
    responsibilities: [],
    associatedWith: 'FiezTech Pvt Ltd',
    stack: ['rails', 'reactjs', 'redux', 'nodejs', 'elixir', 'bootstrap', 'gitlab', 'postgresql', 'microservices', 'aws', 'ec2', 'rest api', 'jira', 'postman', 'slack'],
    images: [z98Image],
    domains: ['https://invoteams.com/'],
    sourceCode: '',
  },
  {
    name: 'Vintage Domus',
    from: 'Sep 2023',
    to: 'May 2024',
    headline: 'AI-Powered hiring software solution for streamlined software development',
    description: 'AI-Powered hiring software solution for streamlined software development',
    features: [],
    responsibilities: [],
    associatedWith: 'FiezTech Pvt Ltd',
    stack: ['rails', 'reactjs', 'redux', 'nodejs', 'elixir', 'bootstrap', 'gitlab', 'postgresql', 'microservices', 'aws', 'ec2', 'rest api', 'jira', 'postman', 'slack'],
    images: [vintagedomusImage],
    domains: ['https://invoteams.com/'],
    sourceCode: '',
  },
  {
    name: 'InvoTeams',
    from: 'Mar 2023',
    to: 'Sep 2023',
    headline: 'AI-Powered hiring software solution for streamlined software development',
    description: 'AI-Powered hiring software solution for streamlined software development',
    features: [],
    responsibilities: [],
    associatedWith: 'InvoZone Pvt Ltd.',
    stack: ['rails', 'reactjs', 'redux', 'nodejs', 'elixir', 'bootstrap', 'gitlab', 'postgresql', 'microservices', 'aws', 'ec2', 'rest api', 'jira', 'postman', 'slack'],
    images: [invoteamsImage],
    domains: ['https://invoteams.com/'],
    sourceCode: '',
  },
  {
    name: 'FreshPrep',
    from: 'Nov 2022',
    to: 'Mar 2023',
    headline: 'Fresh Prep — Western Canada’s most convenient and sustainable meal kit delivery service.',
    description: 'Fresh Prep — Western Canada’s most convenient and sustainable meal kit delivery service.',
    features: [],
    responsibilities: [],
    associatedWith: 'InvoZone Pvt Ltd.',
    stack: ['rails', 'vuejs', 'bootstrap', 'bitbucket', 'postgresql', 'redis', 'aws', 'ec2', 'rest api', 'circleci', 'rspec', 'jira', 'postman', 'slack'],
    images: [freshprepImage],
    domains: ['	https://www.freshprep.ca/'],
    sourceCode: '',
  },
  {
    name: 'LooperInsights',
    from: 'Mar 2022',
    to: 'Nov 2022',
    headline: 'Looper insights headline',
    description: 'A web app made in ruby on rails and vue.js to track menus across Connected TV devices and Web Stores',
    features: [],
    responsibilities: [],
    associatedWith: 'InvoZone Pvt Ltd.',
    stack: ['rails', 'vuejs', 'bootstrap', 'github', 'postgresql', 'redis', 'aws', 'ec2', 'docker', 'rest api', 'circleci', 'rspec', 'jira', 'postman', 'slack'],
    images: [looperinsightsImage],
    domains: ['https://looperinsights.com/'],
    sourceCode: '',
  },
  {
    name: 'AppWorkCo',
    from: 'Aug 2021',
    to: 'Feb 2022',
    headline: 'AppWorkCo: Redefining Multifamily Maintenance Management',
    description: 'Apprent now (Appwrork) is created by those who understand a property manager’s needs best. This software offers a simple and easy way to pay rent, submit work orders and much more.',
    features: [],
    responsibilities: [],
    associatedWith: 'InvoZone Pvt Ltd.',
    stack: ['elixir', 'phoenix', 'nodejs', 'reactjs', 'redux', 'tailwindcss', 'github', 'postgresql', 'redis', 'aws', 'ec2', 'rest api', 'honeybadger', 'jest', 'jira', 'postman', 'slack'],
    images: [appworkcoImage],
    domains: ['	https://appworkco.com/', '	Client domain: https://residents.apprent.com/', '	Admin domain: https://administration.apprent.com/'],
    sourceCode: '',
  },
  {
    name: 'Retainoo - Salon Software',
    from: 'Mar 2020',
    to: 'Aug 2021',
    headline: 'Salon Management Software & App Platform',
    description: 'Salon Management Software & App Platform provides all-in-one hair & beauty online software and client retention solution.',
    features: [],
    responsibilities: [],
    associatedWith: 'Cybernest Pvt Ltd.',
    stack: ['ruby', 'rails', 'javascript', 'reactjs', 'html5', 'css3', 'mysql', 'git', 'jira', 'postman'],
    images: [retainooImage],
    domains: ['https://retainoo.com/'],
    sourceCode: '',
  },
]

const educations = [
  {
    institute: 'Vrije Universiteit Brussel',
    program: 'Master in Computer Science',
    year: '2025',
    grade: '',
    location: 'Brussels, Belgium',
    image: vubImage,
    link: '',
    description: ''
  },
  {
    institute: 'University of Central Punjab',
    program: 'Bachelor in Computer Science',
    year: '2021',
    grade: 'A',
    location: 'Lahore, Pakistan',
    image: ucpImage,
    link: '',
    description: ''
  },
  {
    institute: 'Punjab Group of Colleges',
    program: 'FSc. Pre. Engineering',
    year: '2016',
    grade: '',
    location: 'Lahore, Pakistan',
    image: pgcImage,
    link: '',
    description: ''
  }
]

const skills = {
  frontend: [
    {
      name: "React",
      icon: "reactjs"
    },
    {
      name: "Next.js",
      icon: "nextjs"
    },
    {
      name: "Redux",
      icon: "redux"
    },
    {
      name: "Vue.js",
      icon: "vuejs"
    },
    {
      name: "HTML",
      icon: "html5"
    },
    {
      name: "CSS",
      icon: "css3"
    },
    {
      name: "SASS",
      icon: "sass"
    },
    {
      name: "Material UI",
      icon: "materialui"
    },
    {
      name: "Bootstrap",
      icon: "bootstrap5"
    },
    {
      name: "Tailwind",
      icon: "tailwindcss"
    }
  ],
  backend: [
    {
      name: "JavaScript",
      icon: "js"
    },
    {
      name: "Ruby on Rails",
      icon: "rails"
    },
    {
      name: "Elixir",
      icon: "elixir"
    },
    {
      name: "Phoenix",
      icon: "phoenix"
    },
    {
      name: "Node.js",
      icon: "nodejs"
    },
    {
      name: "TypeScript",
      icon: "typescript"
    },
    {
      name: "NPM",
      icon: "npm"
    },
    // {
    //   name: "Python",
    //   icon: "python"
    // }
  ],
  devops: [
    {
      name: "AWS",
      icon: "aws"
    },
    {
      name: "AWS EC2",
      icon: "ec2"
    },
    {
      name: "CI/CD Pipeline",
      icon: "ci-cd"
    },
    {
      name: "Cloudflare",
      icon: "cloudflare"
    },
    {
      name: "Docker",
      icon: "docker"
    },
    {
      name: "Linux",
      icon: "linux"
    },
    {
      name: "Azure",
      icon: "azure"
    },
    {
      name: "Kubernetes",
      icon: "kubernetes"
    },
    {
      name: "DigitalOcean",
      icon: "digitalocean"
    },
    {
      name: "Heroku",
      icon: "heroku"
    }
  ],
  databases: [
    {
      name: "PostgreSQL",
      icon: "postgresql"
    },
    {
      name: "MySQL",
      icon: "mysql"
    },
    // {
    //   name: "SQL Server",
    //   icon: "sql-server"
    // },
    {
      name: "MongoDB",
      icon: "mongodb"
    },
    {
      name: "Redis",
      icon: "redis"
    },
    {
      name: "Elasticsearch",
      icon: "elastic"
    },
  ],
  tools: [
    {
      name: "Git",
      icon: "git"
    },
    {
      name: "RESTful APIs",
      icon: "restful-api"
    },
    {
      name: "GraphQL",
      icon: "graphql"
    },
    {
      name: "OpenAI",
      icon: "openai"
    },
    {
      name: "Swagger",
      icon: "swagger"
    },
    {
      name: "AWS S3",
      icon: "s3"
    },
    {
      name: "Jest",
      icon: "jest"
    },
    {
      name: "RSpec",
      icon: "rspec"
    },
    {
      name: "CircleCI",
      icon: "circleci"
    },
    {
      name: "Jenkins",
      icon: "jenkins"
    },
    {
      name: "Jira",
      icon: "jira"
    },
    {
      name: "Postman",
      icon: "postman"
    },
    {
      name: "Slack",
      icon: "slack"
    }
  ]
};

export { header, about, projects, skills, contact, experiences, educations, feedbacks }
